import { SVG } from '../SVG'

const InfoIcon = ({ style = {}, ...props }) => (
  <SVG
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'var(--primary-color)', ...style }}
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.0003 1C5.03267 1 1 5.03267 1 10.0003C1 14.968 5.03267 19.0007 10.0003 19.0007C14.968 19.0007 19.0007 14.968 19.0007 10.0003C19.0007 5.03267 14.9673 1 10.0003 1ZM10.0003 8.32592C9.66746 8.32592 9.34798 8.45786 9.11222 8.69362C8.87713 8.92938 8.74452 9.24886 8.74452 9.58173V15.0236C8.74452 15.3571 8.87646 15.6759 9.11222 15.9117C9.34798 16.1468 9.66746 16.2794 10.0003 16.2794C10.3332 16.2794 10.6527 16.1468 10.8884 15.9117C11.1235 15.6759 11.2561 15.3565 11.2561 15.0236V9.58173C11.2561 9.24886 11.1242 8.92938 10.8884 8.69362C10.6527 8.45853 10.3332 8.32592 10.0003 8.32592ZM10.0003 3.51163C10.8087 3.51163 11.4658 4.168 11.4658 4.97708C11.4658 5.78616 10.8094 6.44253 10.0003 6.44253C9.19126 6.44253 8.53488 5.78616 8.53488 4.97708C8.53488 4.168 9.19126 3.51163 10.0003 3.51163Z'
    />
  </SVG>
)

export default InfoIcon
